import React, { useEffect, useState } from "react";
import { useStyletron } from "styletron-react";
import { connect } from "react-redux";
import TemplateInputItem from "./TemplateInputItem";
import EmptyListNotificationComponent from "../../components/empty-list-notification/EmptyListNotificationComponent";
import { deleteParameterItem, updateParameterItem } from "../../redux/template/TemplateThunk";

function TemplateParameterDetailMainView({ items: propItems, groups: propGroups, onUpdateTemplateItemProps, ondeleteTemplateItem, ...props }) {
  const [css] = useStyletron();
  const [items, setItems] = useState(propItems);
  const [groups, setGroups] = useState(propGroups);
  const warningMessage = props.groupSelected ?  "Groups serve as organizational containers for parameters. It is necessary to include parameters within these groups." : "No group has been selected.";
  useEffect(() => {
    setItems(propItems);
    setGroups(propGroups);
  }, [propItems, propGroups]);

  const handleItemPropsChange = (newItem) => {
    console.log(newItem);
    onUpdateTemplateItemProps(newItem);
  };

  const handleItemsChanged = (oldIndex, newIndex) => {
    if (newIndex === -1) {
      ondeleteTemplateItem(items[oldIndex].id);
    } 
  };

  return (
    <div
      className={css({ width: "100%" })}
      onChange={({ oldIndex, newIndex }) => handleItemsChanged(oldIndex, newIndex)}
    >
      {items && items.length > 0 ? (
        items.map((item) => (
          <TemplateInputItem
            key={item.id}
            item={item}
            allGroups={groups}
            handleItemPropsChanged={handleItemPropsChange}
          />
        ))
      ) : (
        <EmptyListNotificationComponent message={warningMessage} />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  items: state.template.activeTemplate?.selectedGroup?.children,
  groups: state.template.activeTemplate?.parameterGroups,
  groupSelected: Object.keys(state.template.activeTemplate?.selectedGroup || {}).length > 0 
  ? state.template.activeTemplate?.selectedGroup 
  : null,
});

const mapDispatchToProps = {
  ondeleteTemplateItem: deleteParameterItem,
  onUpdateTemplateItemProps: updateParameterItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateParameterDetailMainView);
